module.exports = __webpack_public_path__ + "static/media/minus.97e73ce4.svg";